import { render, staticRenderFns } from "./AiCallingCallHistory.vue?vue&type=template&id=4fd4018c&scoped=true&"
import script from "./AiCallingCallHistory.vue?vue&type=script&lang=js&"
export * from "./AiCallingCallHistory.vue?vue&type=script&lang=js&"
import style0 from "./AiCallingCallHistory.vue?vue&type=style&index=0&id=4fd4018c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4018c",
  null
  
)

export default component.exports